export default "__VITE_ASSET__D2i7NQzk__"